export enum WREX_QUOTE {
    /**
     * @value Quote
     * @description The label of the Quote block button, to wrap the current selection in a quote block.
     */
    QUOTE_BLOCK_BUTTON = 'FRONT.TEXT_EDITOR.FORMAT.QUOTE_BLOCK_BUTTON',
}
